<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { ElLoading } from 'element-plus';
import { apiGetCustomerInfo, apiScanQRCode } from '@/api';
import { useScanQrcodeStore } from '@/store';
import { STAMP_STATUS, STATUS_VERIFY, TEMPLATE_TYPES, VERIFICATION_TYPE } from '@/constants';

import TemplateOne from '@/components/templates/verifies/TemplateOne.vue';
import TemplateTwo from '@/components/templates/verifies/TemplateTwo.vue';
import TemplateThree from '@/components/templates/verifies/TemplateThree.vue';
import { isEmpty } from '@/utitls';

const { t: $t } = useI18n();
const { query } = useRoute();
const router = useRouter();
const store = useScanQrcodeStore();
const stampCodeStatus = ref('');
const isProduct = ref(false);
const isLoading = ref(true);
onMounted(async () => {
  const { xid, serial, ser, type, user_uuid, preview, utm } = query;
  const serialx = serial || ser;
  const browser_id = window.localStorage.getItem('browser_id');
  const scanType = type || VERIFICATION_TYPE.LANDING_PAGE;

  const bgLoading = ElLoading.service({
    lock: true,
    text: $t('common.loading'),
    background: 'rgba(0, 0, 0, 0.7)',
  });

  try {
    const response = await apiScanQRCode({
      xid,
      serial: serialx,
      type: scanType,
      browser_id,
      preview,
      user_uuid,
      utm,
    });

    const { data: dataResponse } = response.data;
    if (!isEmpty(dataResponse?.product)) {
      await bgLoading.close();
      await (isLoading.value = false);
      isProduct.value = true;
    }

    stampCodeStatus.value = dataResponse?.stamp_code?.status || '';

    if (stampCodeStatus.value === 'not_found') {
      await router.push({ name: 'not-found' });
      return;
    }

    store.setDataScanQrcode(dataResponse);

    const hasStampError = [
      STAMP_STATUS.NEW,
      STAMP_STATUS.BLOCKED,
      STATUS_VERIFY.CANNOT_ACCESS,
    ].includes(stampCodeStatus.value);

    if (hasStampError) {
      await router.push({ name: 'stamp-error' });
      return;
    }

    // Xử lý thành công → hiển thị tiếp
  } catch (e) {
    await router.push({ name: 'error' });
  }
});

const templateCode = computed(() => store?.template?.code || 'mrw_template_1');
</script>

<template>
  <div class="qrx-container m-auto overflow-hidden">
    <el-table
      v-if="isLoading"
      v-loading="isLoading"
      element-loading-text="Hệ thống đang xác thực, vui lòng chờ trong giây lát..."
      style="width: 100vw; height: 100vh"
    >
      <el-table-column>
        <template #default>
          <div class="text-center">
            <el-image
              style="width: 200px; height: 200px"
              src="@/assets/images/loading.gif"
              fit="contain"
            />
            <div class="text-[16px] font-medium mt-4">
              {{ $t('common.loading') }}
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <template v-else>
      <template v-if="templateCode === TEMPLATE_TYPES.TEMPLATE_3">
        <TemplateThree />
      </template>
      <template v-else-if="templateCode === TEMPLATE_TYPES.TEMPLATE_2">
        <TemplateTwo />
      </template>
      <template v-else>
        <TemplateOne />
      </template>
    </template>
  </div>
</template>
